// -*-mode: rjsx -*-

import React from "react"
import axios from "axios"


// LOGGING SETUP
import appConfig from "./App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<AppContext>")


const AppContext = React.createContext({
    isPreloading: true,
    jsons: {},
    setJson: () => {},
    setPreloading: () => {},
    preload: () => {},
    somefunc: () => {
	console.log("AppContext: somefunc")
    }
})


class AppContextProvider extends React.Component {
    constructor(props) {
        super(props);

        const axiosInstance = axios.create({
            baseURL: "https://storage.googleapis.com/lightning-flash-public-01/",
            withCredentials: false,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods':'GET',
            }
        })
	
        const setJson = (key, json) => {
            log.trace("<AppContextProvider>: setJson()")
            this.setState(state => ({
                jsons: {
                    ...state.jsons,
                    [key]: json
                }
            }))
        }

        const getJson = (key) => {
            if(!this.state.jsons[key]) {
                return undefined
            } else if(this.state.jsons[key].isLoading) {
                return undefined
            } else {
                return this.state.jsons[key]
            }
        }

        const fetchJson = async (key, url) => {
            log.trace("<AppContextProvider>: fetchJson(): url =",url)

            try {
                const result = await axiosInstance.get(url)
                log.trace("fetchJson(): result =", result)
                
                this.setState(state => ({
                    jsons: {
                        ...state.jsons,
                        [key]: {
                            isLoading: false,
                            //                            data: `received data for key = ${key}`
                            data: result.data
                        }
                    }
                }))
            } catch (error) {
                log.trace("<AppContextProvider>: fetchJson(): error =",error)
            }
        }

        const preload = (keys) => {
            keys.forEach(key => {
                let jsonName
                switch(key) {
                case "NATIONAL":
                    jsonName = "us_state.json.gz"
                    break
                case "STATE":
                    jsonName = "us_cd_500k-0001-mini-rich.json.gz"
                    break
                case "SSD":
                    //jsonName = "us_cd_500k-0001-mini-rich.json.gz" // correct
                    // jsonName = "us_zcta510_500k-0001-mini-rich-subset.json.gz"
                    jsonName = "ssdzip.us_zcta510_500k-0001-mini-rich-subset.json"
                    break
                case "USCD":
                    jsonName = "us_zcta510_500k-0001-mini-rich-subset.json.gz"
                    break
                case "USCD-unzipped":
                    jsonName = "us_zcta510_500k-0001-mini-rich-subset.json"
                    break
                default:
                    log.error(`<AppContextProvider>: preload(): ERROR: could not find key = ${key}`)
                } // end of switch

                if(jsonName) {
                    if(!this.state.jsons[key]) {
                        log.trace(`<AppContextProvider>: preload(): key = ${key} is new, load jsonName =`, jsonName)
                        setJson(key, {isLoading: true, "data": {}}) // set initial values
                        fetchJson(key, jsonName) // will set new values
                    } else {
                        if(this.state.jsons[key].isLoading === true) {
                            log.trace(`<AppContextProvider>: preload(): key = ${key} is already loading...`)
                        } else {
                            log.trace(`<AppContextProvider>: preload(): key = ${key} has already loaded`)
                        }
                    }
                } else {
                    log.trace(`<AppContextProvider>: preload(): error: could not map key = ${key}`)
                }
            })}
        
        const setPreloading = (value) => {
            log.trace("<AppContextProvider>: setPreloading(): value =",value)
            this.setState(state => ({
                isPreloading: value
            }))
        }

        this.state = {
            isPreloading: true,
            jsons: {},
            setJson: setJson,
            getJson: getJson,
            setPreloading: setPreloading,
            preload: preload
        }
    }
    
    render() {
        const { children } = this.props
        return (
            <AppContext.Provider value={this.state}>
              {children}
            </AppContext.Provider>
        )
    }
    
}

export default AppContext

export { AppContextProvider }
